import { useMemo } from 'react';
import { useShouldShowIAFeature } from 'hooks/IAFeaturesHook';
import Organization from 'infrastructure/Organization';
import { useGetFF } from 'hooks/useGetFF';

export const useShouldShowRealPlaysModal = () => {
  const enabled = useShouldShowIAFeature('ai_realplays');
  const active = useMemo(() => enabled, [enabled]);
  return { active };
};

export const useShouldShowRealPlaysPage = () => {
  const org_id = Organization.getSelectedOrg()?.slug;
  const { isEnabled, value, loading } = useGetFF({ flag_id: 'ai_realplays' });
  const ai_integration = Organization.getSelectedOrg()?.ai_integration;

  const enabled = useMemo(() => {
    if (isEnabled && ai_integration && value !== '') {
      if (!value?.checkBySlug) return true;
      return value?.slugs?.includes(org_id) ?? false;
    }
    return false;
  }, [isEnabled, ai_integration, org_id, value]);

  return { loading, enabled };
};

export const useShouldManagerOptionInModal = () => {
  const enabled = useShouldShowIAFeature('manager_option');
  const managerOption = useMemo(() => enabled, [enabled]);
  return { managerOption };
};

export const useShouldShowNewIAReport = () => {
  const org_id = Organization.getSelectedOrg()?.slug;
  const { isEnabled, value, loading } = useGetFF({ flag_id: 'realplay_report' });
  const ai_integration = Organization.getSelectedOrg()?.ai_integration;

  const enabled = useMemo(() => {
    if (isEnabled && ai_integration && value !== '') {
      if (!value?.checkBySlug) return true;
      return value?.slugs?.includes(org_id) ?? false;
    }
    return false;
  }, [isEnabled, ai_integration, org_id, value]);

  return { enabled, isLoading: loading };
};


export const useShouldShowNewRolePlayChanges = () => {
 const { isEnabled, value, loading } = useGetFF({ flag_id: 'roleplay_ui_changes' });
  const active = useMemo(() => isEnabled, [isEnabled]);
  return { active };
};